export const SECURE_AUTH_COOKIE_NAME = "medarrive-auth-token";
export const SECURE_REFRESH_COOKIE_NAME = "medarrive-refresh-token";
export const ORG_ID_HEADER_NAME = "medarrive-org-id";
export const SPOOF_LOCATION_HEADER_NAME = "medarrive-location";

// Single window shared by service, web, and mobile for how long an SOS alert
// counts as recent (duplicate blocking, lookback queries, route map range).
export const SOS_ACTIVE_WINDOW_HOURS = 24;
export const SOS_ACTIVE_WINDOW_MS = SOS_ACTIVE_WINDOW_HOURS * 60 * 60 * 1000;
